import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { routes } from "./routes/routes";
import Layout from "./Components/Layout/Layout";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import { AppProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import React, { useEffect } from "react";
import Login from "./Pages/Login/Login";
import AdminLogin from "./Pages/Login/AdminLogin";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./shared/PrivateRoute";
import RegistrationLayout from "./Components/Layout/RegistrationLayout";
import auditLogService from "./services/auditLogService";
import { useCurrentUser } from "./hooks/useAuth";
import { logEvent } from "firebase/analytics";
import { analytics } from "./config/firebase";

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/admin-login",
    element: <AdminLogin />,
  },
  {
    path: "/register",
    element: (
      <ErrorBoundary>
        <PrivateRoute>
          <RegistrationLayout />
        </PrivateRoute>
      </ErrorBoundary>
    ),
  },
  {
    path: "/",
    element: (
      <ErrorBoundary>
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      </ErrorBoundary>
    ),
    children: routes,
  },
]);

function App() {
  const user = useCurrentUser();

  useEffect(() => {
    const handleClick = async (e) => {
      const button = e.target.closest("button[data-track][data-module]");
      if (!button) return;

      const track = button.getAttribute("data-track");
      const module = button.getAttribute("data-module");

      await auditLogService.getAuditLogs({
        event: track,
        user_id: user.uid,
        route: window.location.pathname,
        module: module,
        label: button.innerText.trim(),
      });

      logEvent(analytics, track, {
        module: module,
        label: button.innerText.trim(),
        user_id: user.uid,
        route: window.location.pathname,
      });
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [user]);


  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppProvider>
          <RouterProvider router={router} />
        </AppProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
